import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';
import {
  getSharedVoices,
  getVoices,
} from '@/services/voices-service/voices.service';

export const useVoices = (
  companyId: number | undefined,
  search?: string,
  category?: string,
  pageSize?: number,
  voiceType?: string
) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: ReactQueryKeys.VOICES(companyId, search, category, voiceType),
    queryFn: () =>
      getVoices({
        company_id: companyId!,
        search,
        page_size: pageSize,
        category,
        voice_type: voiceType,
      }),
    enabled: !!companyId,
  });

  return { voices: data?.voices, isPending, isError, error };
};

export const useSharedVoices = (
  companyId: number | undefined,
  search?: string,
  pageSize?: number,
  filters?: { language?: string; gender?: string; accent?: string }
) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: ReactQueryKeys.SHARED_VOICES(companyId, search, filters?.language, filters?.accent, filters?.gender),
    queryFn: () =>
      getSharedVoices({
        company_id: companyId!,
        search,
        page_size: pageSize,
        language: filters?.language,
        gender: filters?.gender,
        accent: filters?.accent,
      }),
    enabled: !!companyId,
  });

  return { voices: data?.voices, isPending, isError, error };
};
